import React, { useState, useRef, useEffect } from "react";
import Button from "../../../Elements/Button/Button.js";
import parse from "html-react-parser";
import config from "config";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import queryString from "query-string";
import Image from "components/Elements/Image/Image.tsx";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { getMailShortDetails } from "../../EmbedFormTemplate/Helpers/EmbedApiCalls.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useCookie } from "contexts/cookieContext/cookieContext.js";
import { useLocation } from "react-router-dom";

import "./EmbedUploader.scss";
import useBucketName from "hooks/useBucketName.ts";

const EmbedMailComplete = ({
  embedFormDetails,
  embedMailId,
  setStartUpload,
  setFinishUpload,
  finishUpload,
  buttonsColor,
  tidParam,
  setEmbedMailId,
  setReSendMail,
}) => {
  const location = useLocation();
  const { getTextByKey, getDirection } = useContent();
  const [orderMailId, setOrderMailId] = useState("");
  const downloadLinkRef = useRef(null);
  const selfRemovalLinkRef = useRef(null);
  const [mailShortKey, setMailShortKey] = useState("");
  const [encryptedSenderMail, setEncryptedSenderMail] = useState("");
  const [hashCodeDeleteMail, setHashCodeDeleteMail] = useState("");
  const { setCookies, getCookie, removeCookies } = useCookie();
  const [loading, setLoading] = useState(true);

  const bucketName = useBucketName({
    encryptedMailId: embedMailId,
  });

  const reSendMail = () => {
    setEmbedMailId(null);
    setStartUpload(false);
    setFinishUpload(false);
    setReSendMail(true);
  };

  const returnErrorConst = (num) => {
    let errText = getTextByKey("api-error");
    errText = errText.replace("#ERRORNUM#", num);
    errText = errText.replace("#SYSMAIL#", "contact-us");
    errText = errText.replace("#SYSMAIL#", config.supportmail);
    errText = errText.replace("#SYSMAIL#", "contact-us");
    return parse(errText);
  };

  const copySelfRemovalLinkToClibord = () => {
    selfRemovalLinkRef.current.select();
    document.execCommand("copy");
  };

  const copyDownloadLinkToClibord = () => {
    downloadLinkRef.current.select();
    document.execCommand("copy");
  };

  const afterUpload = async () => {
    if (finishUpload) {
      const isStatusOK = finishUpload?.exitCode === "ok";
      if (isStatusOK) {
        if (embedMailId) {
          if (!embedFormDetails.IsPickerForm) {
            const res = await getMailShortDetails(embedMailId);
            if (res.data) {
              setOrderMailId(res.data.SentMail_Upload_Session_BigIntID);
              setMailShortKey(res.data.SentMail_Short_Key);
              setHashCodeDeleteMail(res.data.SentMail_Encrypted_DeleteLink);
              setEncryptedSenderMail(res.data.SentMail_Sender_Mail_Encrypted);

              if (
                embedFormDetails &&
                embedFormDetails.Embed_Dynamic_End_Redirect &&
                embedFormDetails.Embed_Dynamic_End_Redirect_Url
              ) {
                const dnParam =
                  res.data.SentMail_Upload_Session_BigIntID.toString();
                const tid = tidParam;
                let fullUrl = `${embedFormDetails.Embed_Dynamic_End_Redirect_Url}?dn=${dnParam}`;
                if (tid) {
                  fullUrl += `&tid=${tid}`;
                }

                window.location.href = fullUrl;
              } else {
                setLoading(false);
              }
            }
          } else {
            const searchParams = queryString.parse(location.search);
            //if the form is picker
            const tidParam = searchParams["tid"];
            const cookieName = `JMPicker-${tidParam}`;
            //check if exists cookie and if exists, remove it
            if (getCookie(cookieName)) {
              removeCookies(cookieName);
            }
            setCookies(cookieName, "SENT", {
              path: "/",
              domain: ".jumbomail.me",
              expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
            });

            //get the value of &dev parameter
            let devParam = searchParams["dev"];
            //if th value is undefined, set it to ""
            if (devParam === undefined) {
              devParam = "";
            }

            let pickerURL = `https://${devParam}picker-set.jumbomail.me/cussite/?p=info&te=200&jm_uploaded`;
            let paramsToPicker = "&sid=" + embedMailId;
            window.location.href = pickerURL + paramsToPicker;
          }
        }
      } else {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    afterUpload();
  }, [finishUpload]);

  return (
    <div className={`embed-mail-complete ${getDirection()}`}>
      {!loading ? (
        embedFormDetails && finishUpload?.exitCode === "ok" ? (
          <div className="embed-mail-complete-content">
            <Image
              className="mail-image"
              name="embed-forms/ic_mail"
              title=""
              alt=""
            />

            <>
              <div className="success-text">
                <span>{parse(getTextByKey("embed-mail-successfully"))}</span>
              </div>
              <div className="order-text">
                <span>
                  {getTextByKey("embed-mail-order-number")} - {orderMailId}
                </span>
              </div>
              {embedFormDetails.Embed_Dynamic_End_Download_Link && (
                <div className="upload-complete-div-link">
                  <div className="upload-complete-div-link-header">
                    <span className="upload-complete-div-link-title">
                      {getTextByKey("embed-mail-view-download-page-text")}
                    </span>{" "}
                    <Tooltip
                      id={"embed-mail-view-download-page"}
                      tooltipTextKey="embed-mail-view-download-page-tooltip"
                      top
                    >
                      <Icon
                        name="question-circle"
                        iconClass="tooltip-question"
                      />
                    </Tooltip>
                  </div>
                  <div className="upload-complete-div-link-input">
                    <div className="script-code">
                      <input
                        type="text"
                        readOnly
                        ref={downloadLinkRef}
                        value={
                          bucketName
                            ? `https://${bucketName}/j/${mailShortKey}`
                            : `${config.baseurl}/j/${mailShortKey}`
                        }
                      ></input>
                    </div>
                    <div className="icons">
                      <div
                        className="copy-icon"
                        onClick={() => copyDownloadLinkToClibord()}
                      >
                        <Icon title="" name="copy-b" />
                      </div>
                      <a
                        target="_blank"
                        href={
                          bucketName
                            ? `https://${bucketName}/j/${mailShortKey}`
                            : `${config.baseurl}/j/${mailShortKey}`
                        }
                        rel="noopener noreferrer"
                      >
                        <Image name="personal/get-link" title="" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              )}
              {embedFormDetails.Embed_Dynamic_Delete_Mail_Link && (
                <div className="upload-complete-div-link">
                  <div className="upload-complete-div-link-header">
                    <span className="upload-complete-div-link-title">
                      {getTextByKey("self-removal-link-text")}
                    </span>{" "}
                    <Tooltip
                      id={"self-removal-link"}
                      tooltipTextKey="self-removal-link-tooltip"
                      top
                    >
                      <Icon
                        name="question-circle"
                        iconClass="tooltip-question"
                      />
                    </Tooltip>
                  </div>
                  <div className="upload-complete-div-link-input">
                    <div className="script-code">
                      <input
                        type="text"
                        readOnly
                        ref={selfRemovalLinkRef}
                        value={
                          bucketName
                            ? `https://${bucketName}/j/${mailShortKey}/delete/${hashCodeDeleteMail}`
                            : `${config.baseurl}/j/${mailShortKey}/delete/${hashCodeDeleteMail}`
                        }
                      ></input>
                    </div>
                    <div className="icons">
                      <div
                        className="copy-icon"
                        onClick={() => copySelfRemovalLinkToClibord()}
                      >
                        <Icon title="" name="copy-b" />
                      </div>
                      <a
                        target="_blank"
                        href={
                          bucketName
                            ? `https://${bucketName}/j/${mailShortKey}/delete/${hashCodeDeleteMail}`
                            : `${config.baseurl}/j/${mailShortKey}/delete/${hashCodeDeleteMail}`
                        }
                        rel="noopener noreferrer"
                      >
                        <Image name="personal/get-link" title="" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              )}
              {embedFormDetails.Embed_Dynamic_End_Send_Button && (
                <Button
                  onClick={() => reSendMail()}
                  style={{
                    backgroundColor: buttonsColor,
                  }}
                >
                  {getTextByKey("embed-mail-resend")}
                </Button>
              )}
            </>
          </div>
        ) : embedFormDetails && finishUpload.exitCode !== "ok" ? (
          <div className="error-result">{returnErrorConst(999)}</div>
        ) : null
      ) : (
        <div className="loading-div">
          <LoadingImageElement />
        </div>
      )}
    </div>
  );
};

export default EmbedMailComplete;
